import { useParams } from 'react-router-dom'
import FilterButtonLearningMatrix from './Filter/Button'
import SelectLA from './SelectLA'

const Filters = () => {
  const params = useParams()
  const chartType = params['*'].split('/')[0]

  return (
    <div>
      {['curriculum-levels'].includes(chartType) ? (
        <>
          {' '}
          <SelectLA />
        </>
      ) : (
        <FilterButtonLearningMatrix chartType={chartType} />
      )}
    </div>
  )
}

export default Filters
